<!-- Modal.svelte -->
<script>
    let {
        fields,
        rows,
        buttonText = "Add",
        className,
        onUpdateList,
    } = $props();

    import { onMount } from "svelte";

    let listRows = $state(rows || []);

    onMount(() => {
        // console.log("List initialized with rows:", listRows);
    });

    function deleteRow(index) {
        listRows.splice(index, 1);
        listRows = [...listRows];

        onUpdateList(listRows);
    }

    function addRow() {
        if (!listRows) listRows = [];
        listRows.push(fields.map(() => ""));
        listRows = [...listRows];

        onUpdateList(listRows);
    }
</script>

<!-- svelte-ignore a11y_consider_explicit_label -->
<!-- svelte-ignore element_invalid_self_closing_tag -->
<!-- svelte-ignore a11y_consider_explicit_label -->
<div class="list {className}">
    <ul class="list__content">
        {#if listRows}
            {#each listRows as row, indexRow}
                <li class="row">
                    {#each fields as field, index}
                        <label>{field.name}</label>
                        {#if field["type"] === "text"}
                            <input type="text" bind:value={row[index]} />
                        {:else if field["type"] === "number"}
                            <input type="number" bind:value={row[index]} />
                        {:else if field["type"] === "time"}
                            <input type="time" bind:value={row[index]} />
                        {:else if field["type"] === "date"}
                            <input type="date" bind:value={row[index]} />
                        {:else if field["type"] === "select"}
                            <select bind:value={row[index]}>
                                {#each field["options"] as option}
                                    <option value={option.id}
                                        >{option.name}</option
                                    >
                                {/each}
                            </select>
                        {:else}
                            <input type="text" bind:value={row[index]} />
                        {/if}
                    {/each}

                    <button onclick={() => deleteRow(indexRow)}
                        ><i class="icon fal fa-trash-alt" /></button
                    >
                </li>
            {/each}
        {/if}
        <div class="list__btn">
            <button onclick={addRow}>{buttonText}</button>
        </div>
    </ul>
</div>

<style lang="scss">
    @use "./styles/index.scss";
</style>
